import React from 'react';
import Seo from '../components/Seo';
import Hero from '../components/Hero';
import Products from '../components/Products';
import Occasions from '../components/Occasions';
import About from '../components/About';
import Reviews from '../components/Reviews';
import CTA from '../components/CTA';
import FAQ from '../components/FAQ';
import DeliveryChecker from '../components/DeliveryChecker';
import DeliveryAreas from '../components/DeliveryAreas';
import PopularPosts from '../components/PopularPosts';
import BloomingNow from '../components/BloomingNow';
import OrderTodayStrip from '../components/OrderTodayStrip';

export default function HomePage() {
  return (
    <>
      <Seo
        title="same day flower delivery Menlo Park|Redwood City"
        description="Same-day flower delivery for Menlo Park and surrounding areas. A real local florist hand-delivering fresh bouquets same day across Menlo Park, Atherton, Palo Alto, Redwood City, Woodside & Portola Valley. Order before 2 PM for every occasion."
        path="/"
      />
      <Hero />
      <OrderTodayStrip />
      <Products />
      <Occasions />
      <BloomingNow />
      <About />
      <Reviews />
      <PopularPosts />
      <CTA />
      <FAQ />
      <DeliveryChecker />
      <DeliveryAreas />
    </>
  );
}
